var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"order-modal order-modal_mh80"},[_c(_vm.component,{tag:"component",attrs:{"order":_vm.order},on:{"fetch":_vm.onFetch}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }